module.exports = __webpack_public_path__ + "static/fonts/iconfont.503a688.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1683809780211
// module id = wBvH
// module chunks = 44